import type { Release } from '../releases';

export default {
  id: '2026-11-01-estimate-compare-sections',
  at: '2026-11-02T03:45:00Z',
  title: 'Сравнение версий сметы: итоги по разделам',
  modules: ['estimates'],
  items: [
    'В карточке сметы на вкладке «Сравнение версий» появились итоги разделов сметы: сумма каждого раздела в старой и новой версии, разница и число позиций.',
    'Без доступа к суммам видно, какие разделы есть и сколько в них позиций, — без цифр.',
  ],
  why: 'Сравнение показывало позиции и виды затрат, но не отвечало, в каком разделе сметы изменилась стоимость.',
  link: '/estimates',
} satisfies Release;
